module.exports = __webpack_public_path__ + "static/header-0a740b7ca4bb36f8b18495a97e979e6f.png";